enum RouteParameters {
  APPOINTMENT_GID = 'appointmentGid',
  APPOINTMENT_ID = 'appointmentId',
  AVAILABILITY_CONSTRAINT_ID = 'availabilityConstraintId',
  COUNTRY = 'country',
  CUSTOMER_GID = 'customerGid',
  RESERVATION_ID = 'reservationId',
  RESOURCE_ID = 'resourceId',
  SHOP_ID = 'shopId',
}

export { RouteParameters }
